function markupToNode(markup: string): Element {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = markup;

  if (!wrapper.firstElementChild) {
    throw new Error('could not parse markup');
  }

  return wrapper.firstElementChild;
}

function getDebugContainer(): Element {
  let container: Element | null = document.getElementById('loopNowDebugContainer');
  if (!container) {
    container = markupToNode('<div id="loopNowDebugContainer" style="margin-top: 1000px"></div>');
    document.body.appendChild(container);
  }

  return container;
}

function wrapDebugText(msg: string): Element {
  const node = markupToNode(
    '<div style="background: white; color: black; border: 1px solid black; margin: 10px 10px 10px 65px;"></div>',
  ) as HTMLDivElement;
  node.innerText = msg;

  return node;
}

export function addDebugText(msg: string): void {
  getDebugContainer().appendChild(wrapDebugText(msg));
}
